// src/loaders/userProfileLoader.js
import axiosClient from '../api/axiosClient';

export async function userProfileLoader({ params }) {
  try {
    const { data } = await axiosClient.get(`/api/users/${params.userId}`);
    if (!data.success) {
      throw new Response(data.message || 'No se encontró usuario', { status: 404 });
    }
    return { user: data.user };
  } catch (err) {
    // Si es 401 => perfil público, devolvemos null para que el layout lo maneje
    if (err.response?.status === 401) {
      return null;
    }
    throw new Response('Error al cargar perfil', { status: 500 });
  }
}